import request from '@/utils/request'

// 保存分类
export function reqGeocoder(data) {
  return request({
    url: '/admin/common/getGaoDeRegion',
    method: 'post',
    params: data
  })
}

// 企业账号列表ids (map结构)
export function reqCompanyAccountByIds(data) {
  return request({
    url: '/admin/common/companyAccountIds',
    method: 'post',
    params: data
  })
}

